module.exports = __webpack_public_path__ + "static/img/logo_cgm.44a9cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/SteelOApp/pages/Login/Assets/Img/logo_cgm.png
// module id = 4k+V
// module chunks = 0